import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconActivity,
  IconBrandComedyCentral,
  IconBuildingCastle,
  IconBuildingCommunity,
  IconCaretDown,
  IconCheck,
  IconDirections,
  IconEdit,
  IconEqual,
  IconEqualNot,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconGenderFemale,
  IconGenderMale,
  IconGenderThird,
  IconHandStop,
  IconMapPin,
  IconNumbers,
  IconPhone,
  IconPlus,
  IconSearch,
  IconUser,
  IconUsers,
  IconUsersGroup,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useDebouncedState, useHotkeys } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  _timerDelayClick,
  repositoryPos,
  repositoryMdm,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateTime,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import {
  cobalt_blue,
  green,
  navy_blue,
  orange,
  pink,
  teal,
} from "../../../const/variables";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { TblDMCustomer } from "../../../model/TblDMCustomerSell";
import {
  getProvinceSelect,
  getProvinceSelectNew,
  getTblDmCustomerGroupSelect,
  getTblDmEmployeeAll,
} from "../../../service/getSelectApi";
import CreateDataView from "./CreateDataView";
import DetailDataView from "./DetailDataView";
import EditDataView from "./EditDataView";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";

const CustomerList = () => {
  //#region State
  //data and fetching state
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMCustomer[]>([]);
  const [, setDataTemp] = useState<TblDMCustomer[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  // const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);

  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<any[]>([]);
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataDistrictSelect, setDataDistrictSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataProvinceNewSelect, setDataProvinceNewSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneNewSelect, setDataCommuneNewSelect] = useState<
    ComboboxItem[]
  >([]);
  const [employeeMap, setEmployeeMap] = useState<Record<string, string>>({});

  const [search, setSearch] = useState<any>({ ActiveMode: "activeOnly" });
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);
  const [taxCode, setTaxCode] = useDebouncedState<string>("", 300);
  const [cusName, setCusName] = useDebouncedState<string>("", 300);
  const [cusCode, setCusCode] = useDebouncedState<string>("", 300);
  // false: tìm kiếm không tuyệt đối (CusCode), true: tìm kiếm tuyệt đối (CusCodeAbs)
  const [isExactCusCode, setIsExactCusCode] = useState(false);
  const [telephone, setTelephone] = useDebouncedState<string>("", 300);

  // Grid span
  const gridSpan = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "code",
        header: "MSKH",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },

      // {
      //   accessorKey: "a",
      //   header: "Thời gian đăng ký",
      //   size: 30,
      //   Cell: ({ renderedCellValue }: any) => (
      //     <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
      //   ),
      //   enableSorting: false,
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      // },

      // {
      //   accessorKey: "b",
      //   header: "Kết nối lâu dài",
      //   size: 30,
      //   enableSorting: false,
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      // },

      {
        accessorKey: "groupName",
        header: "Nhóm khách hàng",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px" fw={"bold"}>
        //     {renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "companyName",
        header: "Tên doanh nghiệp",
        Cell: ({ renderedCellValue, row }: any) => (
          <>
            {row.original.type?.toString() === "1"
              ? ""
              : row.original.companyName}
          </>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "taxCode",
        header: "Mã số thuế",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute1",
        header: "Đối tượng công nợ",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "debtLimit",
        header: "Giới hạn công nợ",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute2",
        header: "Thời hạn công nợ",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "buyerName",
        header: "Họ và tên",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "sex",
        header: "Giới tính",
        Cell: ({ renderedCellValue }: any) => (
          <>
            <Badge variant="light" color={getColorOfGender(renderedCellValue)}>
              <Flex align={"center"}>{renderGender(renderedCellValue)}</Flex>
            </Badge>
          </>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "birthOfDate",
        header: "Ngày sinh nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTime(renderedCellValue)}</>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "telephoneNumber",
        header: "Số điện thoại",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "email",
        header: "Email",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "provinceName",
        header: "Tỉnh/Thành phố (Trước sáp nhập)",
        size: 225,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "districtName",
        header: "Quận/Huyện (Trước sáp nhập)",
        size: 225,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "communeName",
        header: "Phường/Xã (Trước sáp nhập)",
        size: 225,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "newProvinceName",
        header: "Tỉnh/Thành phố (Sau sáp nhập)",
        size: 225,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "newCommuneName",
        header: "Phường/Xã (Sau sáp nhập)",
        size: 225,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "address",
        header: "Địa chỉ cụ thể",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="11.5px">
              {getValueById(String(renderedCellValue), dataEmployee, "label")}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "lastActiveBy",
        header: "Ng\u01b0\u1eddi active/inactive",
        Cell: ({ row, renderedCellValue }: any) => {
          const mappedName =
            row?.original?.lastActiveByName ??
            employeeMap[String(renderedCellValue)] ??
            "";
          return <>{mappedName || renderedCellValue || ""}</>;
        },
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "lastActiveDate",
        header: "Ng\u00e0y active/inactive",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 130,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {!(
              (String(row?.original?.type) === "3" ||
                String(row?.original?.type) === "4") &&
              location.pathname === "/customer-management/customer-list-no-debt"
            ) && (
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="orange"
                  onClick={async () => {
                    editItem(row.original.id);
                  }}
                >
                  <IconEdit size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            )}

            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label={
                row.original.active === true
                  ? "Ng\u1eebng ho\u1ea1t \u0111\u1ed9ng"
                  : "K\u00edch ho\u1ea1t kh\u00e1ch h\u00e0ng"
              }
            >
              <ActionIcon
                variant="light"
                aria-label="active-inactive-customer"
                color={row.original.active === true ? "violet" : "green"}
                onClick={async () => {
                  await activeCustomer(row.original.id);
                }}
              >
                {row.original.active === true ? (
                  <IconHandStop size={20} stroke={1.5} />
                ) : (
                  <IconActivity size={20} stroke={1.5} />
                )}
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [location, employeeMap, dataEmployee],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  async function activeCustomer(id: string | number) {
    if (!id) {
      NotificationExtension.Warn(
        "Kh\u00f4ng t\u00ecm th\u1ea5y kh\u00e1ch h\u00e0ng!",
      );
      return;
    }
    try {
      const response = await repositoryMdm.post<MessageResponse<boolean>>(
        `/api/v1/TblDmCustomer/active-customer?Ids=${id}`,
        "",
      );
      if (response && response.success) {
        NotificationExtension.Success(
          "C\u1eadp nh\u1eadt tr\u1ea1ng th\u00e1i th\u00e0nh c\u00f4ng!",
        );
        await fetchData();
      } else {
        NotificationExtension.Fails(
          "C\u1eadp nh\u1eadt tr\u1ea1ng th\u00e1i th\u1ea5t b\u1ea1i!",
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleExport = async () => {
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (key === "ActiveMode") {
        return;
      }
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => params.append(key, String(item)));
      } else if (typeof value === "string" && value.length > 0) {
        params.append(key, value);
      }
    });

    if (search?.ActiveMode === "all") {
      params.append("Active", "true");
    } else if (search?.ActiveMode === "inactiveOnly") {
      params.append("Active", "false");
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    if (taxCode.length > 0) {
      url += `&TaxCode=${taxCode}`;
    }

    if (cusName.length > 0) {
      url += `&CusName=${cusName}`;
    }

    if (cusCode.length > 0) {
      url += isExactCusCode ? `&CusCodeAbs=${cusCode}` : `&CusCode=${cusCode}`;
    }

    if (telephone.length > 0) {
      url += `&Telephone=${telephone}`;
    }

    url += `&${params.toString()}`;

    const baseUrl = `/api/v1/ExportExcel/export-customer-list${url}`;

    const _url = BASE_API_MDM + baseUrl;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "danh_sach_khach_hang.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  const dataCustomerGroupSelect = async () => {
    try {
      const getData = await getTblDmCustomerGroupSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblCustomerGroup(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (key === "ActiveMode") {
        return;
      }
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => params.append(key, String(item)));
      } else if (typeof value === "string" && value.length > 0) {
        params.append(key, value);
      }
    });

    if (search?.ActiveMode === "all") {
      params.append("Active", "true");
    } else if (search?.ActiveMode === "inactiveOnly") {
      params.append("Active", "false");
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    if (taxCode.length > 0) {
      url += `&TaxCode=${taxCode}`;
    }

    if (cusName.length > 0) {
      url += `&CusName=${cusName}`;
    }

    if (cusCode.length > 0) {
      url += isExactCusCode ? `&CusCodeAbs=${cusCode}` : `&CusCode=${cusCode}`;
    }

    if (telephone.length > 0) {
      url += `&Telephone=${telephone}`;
    }

    url += `&${params.toString()}`;

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblDmCustomer/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Tạo mới khách hàng!</Title>
        </>
      ),
      size: "auto",
      children: <CreateDataView onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  function editItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Sửa khách hàng!</Title>
        </>
      ),
      size: "auto",
      children: (
        <EditDataView id={id} onClose={fetchData} isCreateBySeller={false} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  function detailItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem chi tiết khách hàng!</Title>
        </>
      ),
      size: "auto",
      children: <DetailDataView id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const optionColorsAccount: Record<
    | "Cá nhân"
    | "Doanh nghiệp"
    | "Doanh nghiệp có hạn mức công nợ"
    | "Nhân viên HACOM",
    string
  > = {
    "Cá nhân": orange.vivid,
    "Doanh nghiệp": navy_blue.base,
    "Doanh nghiệp có hạn mức công nợ": teal.base,
    "Nhân viên HACOM": "linear-gradient(to right, #EA242A, #2A3176)",
  };

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Cá nhân"
              | "Doanh nghiệp"
              | "Doanh nghiệp có hạn mức công nợ"
              | "Nhân viên HACOM"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const getColorOfGender = (genderId: number | string) => {
    switch (genderId) {
      case 1:
        return "green";
      case 2:
        return pink.base;
      case 3:
        return teal.base;
      default:
        return "gray";
    }
  };

  const getDataProvinceId = async () => {
    const res = await getProvinceSelect();
    setDataProvinceSelect(
      res
        ?.filter((item: any) => item.text != null && item.value != null)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        })),
    );
  };

  const fetchDataDistrict = async (id: string) => {
    const dataSearch = `&ProvinceIds=${id}`;

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmDistrict/get-list?Skip=0&Take=100${dataSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.name && item.id)
        ?.map((item: any) => ({
          label: String(item.name),
          value: String(item.id),
        }));
      setDataDistrictSelect(data);
    }
  };

  const fetchDataCommune = async (id: string) => {
    const dataSearch = `&DistrictIds=${id}`;

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommune/get-list?Skip=0&Take=100${dataSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.id && item.name)
        ?.map((item: any) => ({
          label: String(item.name),
          value: String(item.id),
        }));
      setDataCommuneSelect(data);
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceNewSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const fetchEmployeeMap = async () => {
    try {
      const response = await repositoryPos.get<MessageResponse<any[]>>(
        "/api/v1/TblDmEmployee/get-select",
      );
      if (response && response.success && Array.isArray(response.data)) {
        const mapped = response.data.reduce(
          (acc: Record<string, string>, item: any) => {
            const id = String(item?.value ?? "");
            if (!id) return acc;
            const code = item?.att1 ? `${item.att1} - ` : "";
            const name = String(item?.text ?? item?.label ?? item?.name ?? "");
            acc[id] = `${code}${name}`.trim();
            return acc;
          },
          {},
        );
        setEmployeeMap(mapped);
      }
    } catch (error) {
      console.error("Error fetch employee map: ", error);
    }
  };

  const fetchDataCommuneNew = async (id: string) => {
    const dataSearch = `&ProvinceIds=${id}`;

    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/get-select?Active=true${dataSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      setDataCommuneNewSelect(
        result
          ?.filter((item: any) => item.text && item.value)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          })),
      );
    }
  };

  const renderGender = (genderId: number | string) => {
    switch (genderId) {
      case 1:
        return (
          <>
            <IconGenderMale size={14} color={"green"}></IconGenderMale>
            Nam
          </>
        );
      case 2:
        return (
          <>
            <IconGenderFemale size={14} color={pink.base}></IconGenderFemale>
            Nữ
          </>
        );
      case 3:
        return (
          <>
            <IconGenderThird size={14} color={teal.base}></IconGenderThird>
            Khác
          </>
        );
      default:
        return <>Không xác định</>;
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  useEffect(() => {
    Promise.all([
      getDataProvinceId(),
      fetchDataProvinceNew(),
      fetchEmployeeMap(),
      fetchDataEmp(),
    ]);
  }, []);

  useEffect(() => {
    if (search?.ProvinceId && search?.ProvinceId.length > 0) {
      fetchDataDistrict(search?.ProvinceId);
    } else {
      setDataDistrictSelect([]);
    }
  }, [search.ProvinceId]);

  useEffect(() => {
    if (search?.DistrictId && search?.DistrictId.length > 0) {
      fetchDataCommune(search?.DistrictId);
    } else {
      setDataCommuneSelect([]);
    }
  }, [search?.DistrictId]);

  useEffect(() => {
    if (search?.NewProvinceId && search?.NewProvinceId.length > 0) {
      fetchDataCommuneNew(search?.NewProvinceId);
    } else {
      setDataCommuneNewSelect([]);
    }
  }, [search?.NewProvinceId]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },

    localization: _localization,
    //  enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      showColumnFilters: false,
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    //   onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      onDoubleClick: async () => await detailItem(row.original?.id),
      sx: { cursor: "pointer" },
    }),
  });

  useHotkeys([["Enter", async () => await fetchData()]]);
  //#endregion
  const styleGrid = { base: 6, xs: 6, sm: 4, md: 3, lg: 12 / 7 };
  return (
    <>
      <>
        <div
          ref={headerRef}
          style={{
            width: "100%",
            border: "1px solid #dee2e6",
            padding: "10px",
          }}
        >
          <Flex justify={"space-between"}>
            <_breadcrumb></_breadcrumb>
            <Flex
              gap="md"
              justify="flex-end"
              align="center"
              direction="row"
              wrap="wrap"
            >
              <Button
                leftSection={<IconPlus size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  createItem();
                }}
              >
                Thêm mới
              </Button>
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <Button
                    // size="xs"
                    rightSection={
                      <IconCaretDown
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Chức năng
                  </Button>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item
                    leftSection={
                      <IconFileExport
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                    onClick={handleExport}
                  >
                    Export Excel
                  </Menu.Item>
                  <Tooltip label={"Chức năng đang update"}>
                    <Menu.Item
                      leftSection={
                        <IconFileUpload
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                    >
                      Import Excel
                    </Menu.Item>
                  </Tooltip>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          </Flex>
          <Grid align="center" gutter={"xs"} mt={5}>
            <Grid.Col span={styleGrid}>
              <Input
                placeholder="Nhập từ khóa tìm kiếm"
                type="text"
                w={"100%"}
                leftSection={
                  <IconSearch size={"20"} color="#15aabf"></IconSearch>
                }
                defaultValue={keySearch}
                onChange={(e: any) => {
                  setKeySearch(e.currentTarget.value);
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Input
                placeholder="Nhập mã khách hàng"
                type="text"
                w={"100%"}
                leftSection={
                  <IconBrandComedyCentral
                    size={"20"}
                    color="#15aabf"
                  ></IconBrandComedyCentral>
                }
                rightSectionPointerEvents="all"
                rightSection={
                  <Tooltip
                    label={
                      isExactCusCode
                        ? "Tìm kiếm tuyệt đối (nhấn để chuyển sang tìm kiếm không tuyệt đối)"
                        : "Tìm kiếm không tuyệt đối (nhấn để chuyển sang tìm kiếm tuyệt đối)"
                    }
                  >
                    <ActionIcon
                      variant="subtle"
                      color={isExactCusCode ? "teal" : "gray"}
                      aria-label="toggle-exact-search-customer-code"
                      onClick={() => setIsExactCusCode((prev) => !prev)}
                    >
                      {isExactCusCode ? (
                        <IconEqual size={18} stroke={1.5} color="#15aabf" />
                      ) : (
                        <IconEqualNot size={18} stroke={1.5} />
                      )}
                    </ActionIcon>
                  </Tooltip>
                }
                defaultValue={cusCode}
                onChange={(e: any) => {
                  setCusCode(e.currentTarget.value);
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Input
                placeholder="Nhập tên khách hàng"
                type="text"
                w={"100%"}
                leftSection={<IconUser size={"20"} color="#15aabf"></IconUser>}
                defaultValue={cusName}
                onChange={(e: any) => {
                  setCusName(e.currentTarget.value);
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <TextInput
                type="number"
                placeholder="Nhập số điện thoại KH"
                defaultValue={telephone}
                leftSection={<IconPhone size={"20"} color="#15aabf" />}
                onChange={(e) => setTelephone(e.currentTarget.value)}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                size="sm"
                placeholder="Loại khách hàng"
                searchable
                clearable
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                data={[
                  {
                    value: "1",
                    label: "Cá nhân",
                  },
                  {
                    value: "2",
                    label: "Doanh nghiệp",
                  },
                  {
                    value: "3",
                    label: "Doanh nghiệp có hạn mức công nợ",
                  },
                  {
                    value: "4",
                    label: "Nhân viên HACOM",
                  },
                ]}
                leftSection={
                  <IconUsers size={"20"} color="#15aabf"></IconUsers>
                }
                w={"100%"}
                onChange={(e) => {
                  changeSearchValue(e ? e : "", "Type", setSearch);
                }}
                renderOption={renderSelectOptionType}
              />
            </Grid.Col>

            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Nhóm khách hàng"
                searchable
                clearable
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                w={"100%"}
                data={
                  search?.Type
                    ? dataTblCustomerGroup?.filter(
                        (item) => item?.type === search?.Type,
                      )
                    : dataTblCustomerGroup
                }
                leftSection={
                  <IconUsersGroup size={"20"} color="#15aabf"></IconUsersGroup>
                }
                onClick={() => {
                  if (dataTblCustomerGroup.length === 0) {
                    dataCustomerGroupSelect();
                  }
                }}
                onChange={(e) => {
                  changeSearchValue(e ? e : "", "GroupId", setSearch);
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Input
                placeholder="Nhập mã số thuế"
                type="text"
                w={"100%"}
                leftSection={
                  <IconNumbers size={"20"} color="#15aabf"></IconNumbers>
                }
                defaultValue={taxCode}
                onChange={(e: any) => {
                  setTaxCode(e.currentTarget.value);
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Tỉnh/TP (Trước sáp nhập)"
                data={dataProvinceSelect}
                clearable
                searchable
                leftSection={<IconBuildingCastle color="#15aabf" />}
                onChange={(e) => {
                  changeSearchValue(e ? e : "", "ProvinceId", setSearch);
                  changeSearchValue("", "DistrictId", setSearch);
                  changeSearchValue("", "CommuneId", setSearch);
                }}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Quận/Huyện (Trước sáp nhập)"
                data={dataDistrictSelect}
                value={
                  search?.DistrictId && search?.DistrictId?.length > 0
                    ? search?.DistrictId
                    : ""
                }
                clearable
                searchable
                leftSection={<IconBuildingCommunity color="#15aabf" />}
                onChange={(e) => {
                  changeSearchValue(e ? e : "", "DistrictId", setSearch);
                  changeSearchValue("", "CommuneId", setSearch);
                }}
                nothingFoundMessage={
                  search?.ProvinceId && search?.ProvinceId?.length > 0
                    ? "Không tìm thấy dữ liệu !"
                    : "Vui lòng chọn tỉnh/thành phố !"
                }
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Phường/Xã (Trước sáp nhập)"
                data={dataCommuneSelect}
                value={
                  search?.CommuneId && search?.CommuneId?.length > 0
                    ? search?.CommuneId
                    : ""
                }
                clearable
                searchable
                leftSection={<IconDirections color="#15aabf" />}
                onChange={(e) =>
                  changeSearchValue(e ? e : "", "CommuneId", setSearch)
                }
                nothingFoundMessage={
                  search?.DistrictId && search?.DistrictId?.length > 0
                    ? "Không tìm thấy dữ liệu !"
                    : "Vui lòng chọn quận/huyện !"
                }
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Tỉnh/TP (Sau sáp nhập)"
                data={dataProvinceNewSelect}
                clearable
                searchable
                leftSection={<IconBuildingCastle color="#15aabf" />}
                onChange={(e) => {
                  changeSearchValue(e ? e : "", "NewProvinceId", setSearch);
                  changeSearchValue("", "NewCommuneId", setSearch);
                }}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Phường/Xã (Sau sáp nhập)"
                data={dataCommuneNewSelect}
                value={
                  search?.NewCommuneId && search?.NewCommuneId?.length > 0
                    ? search?.NewCommuneId
                    : ""
                }
                clearable
                searchable
                leftSection={<IconDirections color="#15aabf" />}
                onChange={(e) =>
                  changeSearchValue(e ? e : "", "NewCommuneId", setSearch)
                }
                nothingFoundMessage={
                  search?.NewProvinceId && search?.NewProvinceId?.length > 0
                    ? "Không tìm thấy dữ liệu !"
                    : "Vui lòng chọn tỉnh/thành phố !"
                }
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Tr\u1ea1ng th\u00e1i kh\u00e1ch h\u00e0ng"
                value={search?.ActiveMode || "activeOnly"}
                data={[
                  {
                    value: "all",
                    label: "T\u1ea5t c\u1ea3 (active + inactive)",
                  },
                  {
                    value: "activeOnly",
                    label: "Ch\u1ec9 \u0111ang ho\u1ea1t \u0111\u1ed9ng",
                  },
                  {
                    value: "inactiveOnly",
                    label: "Ng\u1eebng ho\u1ea1t \u0111\u1ed9ng",
                  },
                ]}
                leftSection={<IconActivity size={"20"} color="#15aabf" />}
                onChange={(e) => {
                  changeSearchValue(
                    e ? e : "activeOnly",
                    "ActiveMode",
                    setSearch,
                  );
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </div>
        <div>
          <MantineReactTable table={table} />
        </div>
      </>
    </>
  );
};
export default CustomerList;
